import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private activeRequests = 0;
  loading$: Observable<boolean> = this.loadingSubject.asObservable();

  begin() {
    if (this.activeRequests === 0) {
      this.loadingSubject.next(true);
    }
    this.activeRequests++;
  }

  end() {
    this.activeRequests--;
    if (this.activeRequests === 0) {
      this.loadingSubject.next(false);
    }
  }
}
